import { isDataLayerAvailable } from '@/tag-manager';
import { CUSTOM_EVENT_DYNAMIC_EVENT } from '@/tag-manager/constants';

const SEARCH = 'maintenance-search';
const RESULT = 'maintenance-result';

export const MAINTENANCE_LIST_DATA_TEST = {
  searchCta: `${SEARCH}-cta`,
  searchCtaHeaderButton: `${SEARCH}-cta-header-button`,
  searchCtaSubmit: `${SEARCH}-cta-submit`,

  searchHeader: `${SEARCH}-header`,

  result: RESULT,
  resultTitle: `${RESULT}-title`,
  resultDisplayButton: `${RESULT}-display-button`,
  resultPlaceholder: `${RESULT}-placeholder`,
  resultRemark: `${RESULT}-remark`,
  resultBrief: `${RESULT}-brief`,
  resultBriefImage: `${RESULT}-brief-image`,
  resultBriefWarranty: `${RESULT}-brief-warranty`,
  resultBriefSuggestion: `${RESULT}-brief-suggestion`,
  resultBriefDescription: `${RESULT}-brief-description`,
  resultBriefPreventive: `${RESULT}-brief-preventive`,
  resultBriefDealerCta: `${RESULT}-brief-dealer-cta`,
  resultBriefCostFooter: `${RESULT}-brief-cost-footer`,
  resultBriefSpecialCost: `${RESULT}-brief-special-cost`,
  resultBriefRange: `${RESULT}-brief-range`,
  resultBriefRangeItem: `${RESULT}-brief-range-item`,
  resultBriefRangeNavButton: `${RESULT}-brief-range-nav-button`,
  resultBriefModalCheckSystems: `${RESULT}-brief-modal-check-systems`,
  resultBriefModalCheckSystemsOpen: `${RESULT}-brief-modal-check-systems-open`,
  resultBriefModalCheckSystemsClose: `${RESULT}-brief-modal-check-systems-close`,
  resultBriefModalCheckSystemsTitle: `${RESULT}-brief-modal-check-systems-title`,
  resultBriefModalCheckSystemsItem: `${RESULT}-brief-modal-check-systems-item`,
  resultBriefModalCheckSystemsCta: `${RESULT}-brief-modal-check-systems-cta`,
  resultBriefSpecialRemark: `${RESULT}-brief-special-remark`,

  resultTable: `${RESULT}-table`,
  resultTableRow: `${RESULT}-table-row`,
} as const;

export const MAINTENANCE_LIST_DATA_GA = {
  main: 'maintenance-list',
  search: 'maintenance-list-search',
} as const;

export const trackMaintenanceSearch = ({
  group = 'header',
  value,
  url,
}: {
  group: 'header' | 'cta';
  value: string;
  url: string;
}) => {
  if (!isDataLayerAvailable()) return;

  window.dataLayer.push({
    event: CUSTOM_EVENT_DYNAMIC_EVENT,
    event_name: MAINTENANCE_LIST_DATA_GA.search,
    group,
    value,
    url,
  });
};
